export const ModerationActionDTI = {
  RequestModerationButton: 'ModerationAction__RequestModeration__Button',
  InProgressDropdown: 'ModerationAction__InProgress__Dropdown',
  EngineerCheckedButton: 'ModerationAction__EngineerChecked__Button',
  CancelModerationButton: 'ModerationAction__CancelModeration__Button',
  Completed: 'ModerationAction__Completed',
} as const;

export const ModerationNotificationDTI = {
  RequestSent: 'ModerationRequestSentNotification',
  Completed: 'ModerationCompletedNotification',
} as const;
